<div style="margin: 0 auto;">
    @if (ticketPrice) {
        <div>
            @if (ticketPrice.upcomingTicketDetailTokens) {
                <div>
                    @if (ticketPrice.upcomingTicketDetailTokens) {
                        <div>
                            <!-- ***** GA and RS Summary -->
                            <ng-container>
                                <div class="tw-ticket-line-container">
                                    <div class="tw-ticket-line-container-row" style="flex: 1 !important;">
                                        <div>
                                            {{ ticketPrice.priceLevel }} / {{ ticketPrice.priceType }}
                                        </div>
                                    </div>
                                    <div class="tw-ticket-line-container-row" style="flex: 1 !important;">
                                        <div style="text-align: center; white-space: nowrap;">
                                            {{ ticketPrice.upcomingTicketDetailTokens.length }} x
                                        </div>
                                    </div>
                                    <div class="tw-ticket-line-container-row" style="flex: 1 !important;">
                                        <div style="text-align: right; padding-right: 15px;">
                                            <div
                                                style="font-weight: bold;font-size: 16px">{{
                                                    (ticketPrice.serviceCharges + ticketPrice.price) / 100
                                                        | currency :'':'symbol-narrow':'':translate.currentLang
                                                }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="tw-ticket-line-container-row"
                                         style=" flex: 0 !important; margin-top: -12px;position: relative">
                                        <div class="bi-tooltip">
                                            <template #viewInfoTaxPrice></template>
                                        </div>
                                    </div>
                                </div>
                            </ng-container>
                            <!-- ***** GA Only -->
                            @if (ticketPrice.ga && ticketPrice.giftable) {
                                <div class="tw-flex tw-column ">
                                    <div class="tw-ticket-line-container" style="
                border-bottom: #0000000f 1px solid;
                margin: 0;
               max-width: 400px;
">
                                        <div class="tw-ticket-line-container-row tw-flex tw-row" style="gap: 10px;">
                                            <div class="tw-flex tw-column tw-seat">
                                                <div>
                                                    <strong>{{ "title.ticket" | translate }}</strong>
                                                </div>
                                            </div>
                                            @if (isPrintableCategory(ticketPrice.upcomingTicketDetailTokens[0].mailCategory)) {
                                                <div class="tw-flex tw-column tw-seat">
                                                    <div>
                                                        <strong>{{ "client.tickets.print" | translate }}</strong>
                                                    </div>
                                                </div>
                                            }
                                            @if (ticketPrice.giftable) {
                                                <div class="tw-flex tw-column tw-seat">
                                                    <div>
                                                        <strong>{{ "client.tickets.gift" | translate }}</strong>
                                                    </div>
                                                </div>
                                                @if (hasAnyGiftedTickets()) {
                                                    <div class="tw-flex tw-column tw-seat">
                                                        <div>
                                                            <strong>{{ "client.tickets.actions" | translate }}</strong>
                                                        </div>
                                                    </div>
                                                }
                                            }
                                        </div>
                                    </div>
                                    @for (ga of ticketPrice.upcomingTicketDetailTokens; track ga; let i = $index) {
                                        <div class="tw-ticket-line-container"
                                             style="margin: 0 4px; padding: 0;max-width: 400px;">
                                            <div class="tw-ticket-line-container-row tw-flex tw-row"
                                                 style="padding: 5px; gap: 10px;">
                                                <div class="tw-flex tw-column tw-seat">
                                                    <div>#{{ i + 1 }}</div>
                                                </div>
                                                @if (ticketPrice.printable) {
                                                    <div class="tw-flex tw-column tw-seat">
                                                        @if (ga.giftRecipient) {
                                                            <button mat-icon-button disabled
                                                                    [title]="'client.tickets.cannotPrintGifted' | translate">
                                                                <mat-icon aria-label="print tickets disabled">print</mat-icon>
                                                            </button>
                                                        } @else {
                                                            <button class="tw-primary" mat-icon-button color="primary"
                                                                    (click)="printTicket(mail, i)">
                                                                <mat-icon aria-label="print tickets">print</mat-icon>
                                                            </button>
                                                        }
                                                    </div>
                                                }
                                                @if (ticketPrice.giftable) {
                                                    <div class="tw-flex tw-column tw-seat">
                                                        <button
                                                            class="{{ ga.giftRecipient ? 'tw-already-sent' : 'tw-gift-not-sent' }}"
                                                            mat-icon-button
                                                            (click)="openSendTicketDialog(ga.giftRecipient, ga.sodId)"
                                                        >
                                                            <mat-icon aria-label="gift ticket">redeem</mat-icon>
                                                            <span class="tooltip-text">
                                                                {{ ga.giftRecipient ? ("client.tickets.sendAnotherTicketHover" | translate : { email: ga.giftRecipient }) : ("client.tickets.sendTicketsHover" | translate) }}
                                                            </span>
                                                        </button>
                                                    </div>
                                                    @if (hasAnyGiftedTickets()) {
                                                        <div class="tw-flex tw-column tw-seat">
                                                            @if (ga.giftRecipient) {
                                                                <button class="tw-unsend-gift" mat-icon-button color="warn"
                                                                        (click)="cancelGift(ga.sodId, ga.giftRecipient)"
                                                                        [title]="'client.tickets.unsendGift' | translate">
                                                                    <mat-icon aria-label="unsend gift">undo</mat-icon>
                                                                </button>
                                                            }
                                                        </div>
                                                    }
                                                }
                                            </div>
                                        </div>
                                    }
                                </div>
                            }
                            <!-- ***** RS Only -->
                            @if (ticketPrice.rs) {
                                <div class="tw-flex tw-column ">
                                    <div class="tw-ticket-line-container" style="
                border-bottom: #0000000f 1px solid;
                margin: 0;
               max-width: 400px;
">
                                        <div class="tw-ticket-line-container-row tw-flex tw-row" style="gap: 10px;">
                                            @if (ticketPrice.upcomingTicketDetailTokens[0].seat.level) {
                                                <div class="tw-flex tw-column tw-seat"
                                                >
                                                    <div>
                                                        <strong>{{ "client.tickets.level" | translate }}</strong>
                                                    </div>
                                                </div>
                                            }
                                            @if (ticketPrice.upcomingTicketDetailTokens[0].seat.section) {
                                                <div class="tw-flex tw-column tw-seat"
                                                >
                                                    <div>
                                                        <strong>{{ "client.tickets.section" | translate }}</strong>
                                                    </div>
                                                </div>
                                            }
                                            @if (ticketPrice.upcomingTicketDetailTokens[0].seat.row) {
                                                <div class="tw-flex tw-column tw-seat"
                                                >
                                                    <div>
                                                        <strong>{{ "client.tickets.row" | translate }}</strong>
                                                    </div>
                                                </div>
                                            }
                                            @if (ticketPrice.upcomingTicketDetailTokens[0].seat.seat) {
                                                <div class="tw-flex tw-column tw-seat"
                                                >
                                                    <div>
                                                        <strong>{{ "client.tickets.seat" | translate }}</strong>
                                                    </div>
                                                </div>
                                            }

                                            @if (isPrintableCategory(ticketPrice.upcomingTicketDetailTokens[0].mailCategory)) {
                                                <div class="tw-flex tw-column tw-seat">
                                                    <div>
                                                        <strong>{{ "client.tickets.print" | translate }}</strong>
                                                    </div>
                                                </div>
                                            }
                                            @if (ticketPrice.giftable) {
                                                <div class="tw-flex tw-column tw-seat">
                                                    <div>
                                                        <strong>{{ "client.tickets.gift" | translate }}</strong>
                                                    </div>
                                                </div>
                                                @if (hasAnyGiftedTickets()) {
                                                    <div class="tw-flex tw-column tw-seat">
                                                        <div>
                                                            <strong>{{ "client.tickets.actions" | translate }}</strong>
                                                        </div>
                                                    </div>
                                                }
                                            }
                                        </div>
                                    </div>
                                    @for (rs of ticketPrice.upcomingTicketDetailTokens; track rs; let i = $index) {
                                        <div class="tw-ticket-line-container"
                                             style="margin: 0 4px; padding: 0;max-width: 400px;">
                                            <div class="tw-ticket-line-container-row tw-flex tw-row"
                                                 style="padding: 5px; gap: 10px;">
                                                @if (rs.seat.level) {
                                                    <div class="tw-flex tw-column tw-seat">
                                                        <div>
                                                            {{ rs.seat.level }}
                                                        </div>
                                                    </div>
                                                }
                                                @if (rs.seat.section) {
                                                    <div class="tw-flex tw-column tw-seat">
                                                        <div>
                                                            {{ rs.seat.section }}
                                                        </div>
                                                    </div>
                                                }
                                                @if (rs.seat.row) {
                                                    <div class="tw-flex tw-column tw-seat">
                                                        <div>
                                                            {{ rs.seat.row }}
                                                        </div>
                                                    </div>
                                                }
                                                @if (rs.seat.seat) {
                                                    <div class="tw-flex tw-column tw-seat">
                                                        <div>
                                                            {{ rs.seat.seat }}
                                                        </div>
                                                    </div>
                                                }
                                                @if (ticketPrice.printable) {
                                                    <div class="tw-flex tw-column tw-seat">
                                                        @if (rs.giftRecipient) {
                                                            <button mat-icon-button disabled
                                                                    [title]="'client.tickets.cannotPrintGifted' | translate">
                                                                <mat-icon aria-label="print tickets disabled">print</mat-icon>
                                                            </button>
                                                        } @else {
                                                            <button class="tw-primary" mat-icon-button color="primary"
                                                                    (click)="printTicket(mail, i)">
                                                                <mat-icon aria-label="print tickets">print</mat-icon>
                                                            </button>
                                                        }
                                                    </div>
                                                }
                                                @if (ticketPrice.giftable) {
                                                    <div class="tw-flex tw-column tw-seat">
                                                        <button
                                                            class="{{ rs.giftRecipient ? 'tw-already-sent' : 'tw-gift-not-sent' }}"
                                                            mat-icon-button
                                                            (click)="openSendTicketDialog(rs.giftRecipient, rs.sodId)"
                                                        >
                                                            <mat-icon aria-label="gift ticket">redeem</mat-icon>
                                                            <span class="tooltip-text">
                                                                {{ rs.giftRecipient ? ("client.tickets.sendAnotherTicketHover" | translate : { email: rs.giftRecipient }) : ("client.tickets.sendTicketsHover" | translate) }}
                                                            </span>
                                                        </button>
                                                    </div>
                                                    @if (hasAnyGiftedTickets()) {
                                                        <div class="tw-flex tw-column tw-seat">
                                                            @if (rs.giftRecipient) {
                                                                <button class="tw-unsend-gift" mat-icon-button color="warn"
                                                                        (click)="cancelGift(rs.sodId, rs.giftRecipient)"
                                                                        [title]="'client.tickets.unsendGift' | translate">
                                                                    <mat-icon aria-label="unsend gift">undo</mat-icon>
                                                                </button>
                                                            }
                                                        </div>
                                                    }
                                                }
                                            </div>
                                        </div>
                                    }
                                </div>
                            }
                        </div>
                    }
                </div>
            }
        </div>
    }
</div>
